import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const munimappingdialogcolumns: GridColumnConfig[] = [
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Service Code',
    field: 'serviceCode',
    filter: 'text',
    searchable: true,
    editable: true,
  },
  {
    title: 'Predecessor',
    field: 'predecessorNames',
    filter: 'text',
    searchable: true,
  },
  // {
  //   title: 'Base Price ($)',
  //   field: 'price',
  //   filter: 'numeric',
  //   fieldType: 'currency',
  //   searchable: true,
  // },
  // {
  //   title: 'Cut-off Time',
  //   field: 'cutOffTime',
  //   filter: 'text',
  //   searchable: true,
  // },
];
